import type { IStatItem } from "./types";

/** Display-only country metadata; callers retain the original label for drill-down. */
export const getRankingCountry = (label: string, language: string) => {
	const code = label.trim().toUpperCase();
	if (!/^[A-Z]{2}$/.test(code) || code === "XX" || code === "ZZ") return { name: label };
	const flagCode = code === "UK" ? "GB" : code;
	try {
		const name = new Intl.DisplayNames([language], { type: "region", fallback: "none" }).of(flagCode);
		return name ? { name, code, flagCode } : { name: label };
	} catch { return { name: label }; }
};

/** Preserve the existing country-code fallback for responses without icon metadata. */
export const getRankingIcon = (item: IStatItem): "country" | undefined => {
	if (item.icon) return item.icon;
	const rows = item.data as { label: string }[];
	return rows.length > 0 && rows.every(row => /^[A-Za-z]{2}$/.test(row.label)) ? "country" : undefined;
};

export const getRankingMax = (rows: { value: number | number[] }[]): number => rows.reduce((max, row) => {
	const values = Array.isArray(row.value) ? row.value : [row.value];
	const total = values.reduce((sum, value) => Number.isFinite(Number(value)) ? sum + Math.max(0, Number(value)) : sum, 0);
	return Math.max(max, total);
}, 1);
